export interface AdminCustomer {
  id: string;
  email: string;
  full_name: string;
  phone: string | null;
  avatar_url: string | null;
  role: string;
  provider: string;
  locale: string | null;
  default_currency: string | null;
  created_at: string;
  status: string;
  company_name?: string;
  country?: string;
}

export const mockAdminCustomers: AdminCustomer[] = [
  {
    id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    email: 'sarah.kim@lumierbeauty.com',
    full_name: 'Sarah Kim',
    phone: '+1-555-0101',
    avatar_url: null,
    role: 'customer',
    provider: 'email',
    locale: 'en',
    default_currency: 'USD',
    created_at: '2025-01-15T08:30:00Z',
    status: 'active',
    company_name: 'Lumiere Beauty Co.',
    country: 'United States',
  },
  {
    id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    email: 'mark.tan@aseancosmo.com',
    full_name: 'Mark Tan',
    phone: '+65-9123-4567',
    avatar_url: null,
    role: 'customer',
    provider: 'google',
    locale: 'en',
    default_currency: 'SGD',
    created_at: '2025-02-20T10:15:00Z',
    status: 'active',
    company_name: 'ASEAN Cosmo OEM',
    country: 'Singapore',
  },
  {
    id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    email: 'yuki.sato@sakuracosmetics.jp',
    full_name: 'Yuki Sato',
    phone: '+81-90-1234-5678',
    avatar_url: null,
    role: 'customer',
    provider: 'email',
    locale: 'ja',
    default_currency: 'JPY',
    created_at: '2025-03-05T14:20:00Z',
    status: 'active',
    company_name: 'Sakura Cosmetics Japan',
    country: 'Japan',
  },
  {
    id: 'd4e5f6a7-b8c9-0123-defa-234567890123',
    email: 'admin@gbcospack.com',
    full_name: 'System Administrator',
    phone: null,
    avatar_url: null,
    role: 'super_admin',
    provider: 'email',
    locale: 'en',
    default_currency: 'USD',
    created_at: '2024-12-01T00:00:00Z',
    status: 'active',
    company_name: 'GBCOSPACK',
    country: 'China',
  },
  {
    id: 'e5f6a7b8-c9d0-1234-efab-345678901234',
    email: 'factory@packsupplier.cn',
    full_name: 'Wang Li',
    phone: '+86-138-0013-8000',
    avatar_url: null,
    role: 'factory_manager',
    provider: 'email',
    locale: 'zh',
    default_currency: 'CNY',
    created_at: '2025-01-10T09:00:00Z',
    status: 'active',
    company_name: 'Shanghai Premium Packaging',
    country: 'China',
  },
  {
    id: 'f6a7b8c9-d0e1-2345-fabc-456789012345',
    email: 'sales@packsupplier.cn',
    full_name: 'Zhang Wei',
    phone: '+86-139-0013-9000',
    avatar_url: null,
    role: 'sales_manager',
    provider: 'email',
    locale: 'zh',
    default_currency: 'CNY',
    created_at: '2025-01-12T11:30:00Z',
    status: 'active',
    company_name: 'Shanghai Premium Packaging',
    country: 'China',
  },
  {
    id: 'a7b8c9d0-e1f2-3456-abcd-567890123456',
    email: 'linh.nguyen@beautyvn.vn',
    full_name: 'Linh Nguyen',
    phone: '+84-90-123-4567',
    avatar_url: null,
    role: 'customer',
    provider: 'facebook',
    locale: 'vi',
    default_currency: 'USD',
    created_at: '2025-04-10T07:45:00Z',
    status: 'inactive',
    company_name: 'Beauty Vietnam Co.',
    country: 'Vietnam',
  },
  {
    id: 'b8c9d0e1-f2a3-4567-bcde-678901234567',
    email: 'ahmad.hassan@gulfbeauty.ae',
    full_name: 'Ahmad Hassan',
    phone: '+971-50-123-4567',
    avatar_url: null,
    role: 'customer',
    provider: 'google',
    locale: 'ar',
    default_currency: 'USD',
    created_at: '2025-04-22T16:00:00Z',
    status: 'active',
    company_name: 'Gulf Beauty Trading',
    country: 'UAE',
  },
];

export interface MockCompany {
  id: string;
  owner_user_id: string;
  company_name: string;
  country: string;
  business_type: string;
  website: string | null;
  contact_email: string;
  contact_phone: string;
  tax_id: string | null;
  company_size: string;
  status: string;
  created_at: string;
}

export const mockCompanies: MockCompany[] = [
  {
    id: 'c1a2b3c4-d5e6-7890-f1a2-b3c4d5e6f7a8',
    owner_user_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    company_name: 'Lumiere Beauty Co.',
    country: 'United States',
    business_type: 'Cosmetic Brand',
    website: 'https://lumierbeauty.com',
    contact_email: 'sarah.kim@lumierbeauty.com',
    contact_phone: '+1-555-0101',
    tax_id: 'US-123456789',
    company_size: '1-10 employees',
    status: 'active',
    created_at: '2025-01-15T08:30:00Z',
  },
  {
    id: 'd2e3f4a5-b6c7-8901-g2b3-c4d5e6f7a8b9',
    owner_user_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    company_name: 'ASEAN Cosmo OEM',
    country: 'Singapore',
    business_type: 'OEM/ODM',
    website: 'https://aseancosmo.com',
    contact_email: 'mark.tan@aseancosmo.com',
    contact_phone: '+65-9123-4567',
    tax_id: 'SG-987654321',
    company_size: '50-200 employees',
    status: 'active',
    created_at: '2025-02-20T10:15:00Z',
  },
  {
    id: 'e3f4a5b6-c7d8-9012-h3c4-d5e6f7a8b9c0',
    owner_user_id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    company_name: 'Sakura Cosmetics Japan',
    country: 'Japan',
    business_type: 'Cosmetic Brand',
    website: null,
    contact_email: 'yuki.sato@sakuracosmetics.jp',
    contact_phone: '+81-90-1234-5678',
    tax_id: 'JP-456789012',
    company_size: '11-50 employees',
    status: 'active',
    created_at: '2025-03-05T14:20:00Z',
  },
];

export interface MockAddress {
  id: string;
  user_id: string;
  company_id: string | null;
  address_type: string;
  country: string;
  city: string;
  address_line1: string;
  address_line2: string | null;
  postal_code: string;
  recipient_name: string;
  phone: string;
  is_default: boolean;
  created_at: string;
}

export const mockAddresses: MockAddress[] = [
  {
    id: 'ad1a2b3c-4d5e-6f7a-8b9c-0d1e2f3a4b5c',
    user_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    company_id: 'c1a2b3c4-d5e6-7890-f1a2-b3c4d5e6f7a8',
    address_type: 'shipping',
    country: 'United States',
    city: 'Los Angeles',
    address_line1: '1234 Sunset Boulevard, Suite 100',
    address_line2: null,
    postal_code: '90028',
    recipient_name: 'Sarah Kim',
    phone: '+1-555-0101',
    is_default: true,
    created_at: '2025-01-15T08:35:00Z',
  },
  {
    id: 'be2b3c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d',
    user_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    company_id: 'd2e3f4a5-b6c7-8901-g2b3-c4d5e6f7a8b9',
    address_type: 'both',
    country: 'Singapore',
    city: 'Singapore',
    address_line1: '68 Circular Road, #02-01',
    address_line2: null,
    postal_code: '049422',
    recipient_name: 'Mark Tan',
    phone: '+65-9123-4567',
    is_default: true,
    created_at: '2025-02-20T10:20:00Z',
  },
  {
    id: 'cf3c4d5e-6f7a-8b9c-0d1e-2f3a4b5c6d7e',
    user_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    company_id: 'c1a2b3c4-d5e6-7890-f1a2-b3c4d5e6f7a8',
    address_type: 'billing',
    country: 'United States',
    city: 'New York',
    address_line1: '567 Madison Avenue, Floor 12',
    address_line2: 'Billing Department',
    postal_code: '10022',
    recipient_name: 'Sarah Kim',
    phone: '+1-555-0102',
    is_default: false,
    created_at: '2025-03-01T09:00:00Z',
  },
];

export const mockQuotations = [
  { id: 'q1', user_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890', product_name: 'Airless Bottle 50ml', status: 'quoted', quantity: 5000, created_at: '2025-05-10T10:00:00Z' },
  { id: 'q2', user_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890', product_name: 'Cream Jar 30ml', status: 'pending', quantity: 3000, created_at: '2025-05-18T14:30:00Z' },
  { id: 'q3', user_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901', product_name: 'Pump Bottle 100ml', status: 'accepted', quantity: 10000, created_at: '2025-04-22T09:15:00Z' },
];

export const mockOrders = [
  { id: 'o1', user_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890', product_name: 'Airless Bottle 50ml', status: 'production', payment_status: 'paid', total_amount: 8500, created_at: '2025-05-12T11:00:00Z' },
];

export const mockAiPreviews = [
  { id: 'ai1', user_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890', product_name: 'Airless Bottle 50ml', finish_type: 'Glossy Cap', status: 'completed', created_at: '2025-05-09T16:00:00Z' },
  { id: 'ai2', user_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890', product_name: 'Cream Jar 30ml', finish_type: 'Frosted Body', status: 'completed', created_at: '2025-05-17T13:00:00Z' },
];